export interface TeamMembersFilterModel {
  namePattern: string | null
  roleNames: string[]
  statuses: string[]
}

export const defaultTeamMembersFilter: TeamMembersFilterModel = {
  namePattern: null,
  roleNames: [],
  statuses: ['active'],
}
